import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap"
import {
  createRole,
  deleteRole,
  getAdminRoles,
  getRole,
  hideAdminRoleModal,
  hideDeleteRoleModal,
  openAdminRoleModal,
  openDeleteRoleModal,
  resetRole,
  updateRole,
} from "store/actions"
import AdminRoleForm from "./adminRoleForm"

const AdminRoles = ({
  getAdminRoles,
  adminRoles,
  hideAdminRoleModal,
  openAdminRoleModal,
  adminRoleModalIsOpen,
  selectedRole,
  getRole,
  resetRole,
  createRole,
  updateRole,
  loading,
  openDeleteRoleModal,
  hideDeleteRoleModal,
  deleteRoleModalIsOpen,
  deleteRole,
}) => {
  const [selectedRoleForDelete, setSelectedRoleForDelete] = useState()

  useEffect(() => {
    getAdminRoles()
  }, [])

  const handleSave = data => {
    if (selectedRole) {
      updateRole({ ...selectedRole, ...data })
    } else {
      createRole(data)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Admin Roles" />
        <Container fluid>
          <BreadcrumbTitle
            title="Admin Roles"
            breadcrumbItems={[{ title: "Dashboard" }, { title: "Admin Roles" }]}
          />
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Add Role"
                onClick={openAdminRoleModal}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Table
                hover
                className="project-list-table table-nowrap align-middle table-borderless"
              >
                <tbody>
                  {adminRoles?.map(role => (
                    <tr key={role?.id}>
                      <td>
                        <h5 className="text-truncate font-size-14">
                          {role.name}
                        </h5>
                        <p className="text-muted mb-0">{role.description}</p>
                      </td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle className="card-drop" tag="a">
                            <i className="mdi mdi-dots-vertical font-size-18" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem
                              href="#"
                              onClick={e => {
                                e.preventDefault()
                                getRole({ id: role?.id })
                                openAdminRoleModal()
                              }}
                            >
                              <i className="bx bx-edit font-size-14  me-1" />
                              Edit
                            </DropdownItem>
                            <DropdownItem
                              href="#"
                              onClick={e => {
                                e.preventDefault()
                                setSelectedRoleForDelete(role)
                                openDeleteRoleModal()
                              }}
                            >
                              <i className="bx bx-trash  font-size-14  me-1" />
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={adminRoleModalIsOpen}
          toggle={hideAdminRoleModal}
          centered={true}
          onClosed={() => {
            if (selectedRole) {
              resetRole()
            }
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0">
              {selectedRole
                ? `Edit "${selectedRole?.name}" role`
                : "Add a role"}
            </h5>
            <button
              type="button"
              onClick={hideAdminRoleModal}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <AdminRoleForm
              onSubmit={handleSave}
              handleClose={hideAdminRoleModal}
              initialValues={
                selectedRole && {
                  ...selectedRole,
                }
              }
              loading={loading}
            />
          </div>
        </Modal>
        <ModalComponent
          open={deleteRoleModalIsOpen}
          onClose={hideDeleteRoleModal}
          title={`Delete role - "${selectedRoleForDelete?.name}"`}
        >
          <Row>
            <Col>
              <h5>
                By proceeding, you will delete the role{" "}
                <i>{selectedRoleForDelete?.name}</i>.
              </h5>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end mt-1">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Cancel"
                onClick={hideDeleteRoleModal}
                color="danger"
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Delete"
                onClick={() => {
                  deleteRole({ id: selectedRoleForDelete?.id })
                }}
              />
            </Col>
          </Row>
        </ModalComponent>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => ({
  adminRoles: state.Roles.adminRoles,
  adminRoleModalIsOpen: state.Roles.adminRoleModalIsOpen,
  selectedRole: state.Roles.selectedRole,
  loading: state.Roles.loading,
  deleteRoleModalIsOpen: state.Roles.deleteRoleModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getAdminRoles: values => dispatch(getAdminRoles(values)),
  openAdminRoleModal: () => dispatch(openAdminRoleModal()),
  hideAdminRoleModal: () => dispatch(hideAdminRoleModal()),
  getRole: values => dispatch(getRole(values)),
  resetRole: () => dispatch(resetRole()),
  createRole: values => dispatch(createRole(values)),
  updateRole: values => dispatch(updateRole(values)),
  openDeleteRoleModal: () => dispatch(openDeleteRoleModal()),
  hideDeleteRoleModal: () => dispatch(hideDeleteRoleModal()),
  deleteRole: values => dispatch(deleteRole(values)),
})

export default connect(mapStatetoProps, mapDispatchToProps)(AdminRoles)
